import { render, staticRenderFns } from "./ValidateEmailRegistration.vue?vue&type=template&id=157598f3&scoped=true"
import script from "./ValidateEmailRegistration.vue?vue&type=script&lang=js"
export * from "./ValidateEmailRegistration.vue?vue&type=script&lang=js"
import style0 from "./ValidateEmailRegistration.vue?vue&type=style&index=0&id=157598f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157598f3",
  null
  
)

export default component.exports